import React from 'react';
import { HashRouter, Routes, Route } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Footer } from './components/Footer';
import { ScrollToTop } from './components/ScrollToTop';
// Pages
import { HomePage } from './pages/HomePage';
import { SectorsHubPage } from './pages/SectorsHubPage';
import { SectorPage } from './pages/SectorPage';
import { FrameworksPage } from './pages/FrameworksPage';
import { CapabilitiesHubPage } from './pages/CapabilitiesHubPage';
import { CapabilityPage } from './pages/CapabilityPage';
import { ProductsHubPage } from './pages/ProductsHubPage';
import { ProductPage } from './pages/ProductPage';
import { ContactPage } from './pages/ContactPage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { TermsOfServicePage } from './pages/TermsOfServicePage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
import { SupplierNetworkPage } from './pages/SupplierNetworkPage';
import { WhoWeArePage } from './pages/WhoWeArePage';
import { NotFoundPage } from './pages/NotFoundPage';
import { CookieBanner } from './components/CookieBanner';
import { BackToTopButton } from './components/BackToTopButton';
// New Pages
import { AboutHubPage } from './pages/AboutHubPage';
import { WhatWeDoPage } from './pages/WhatWeDoPage';
import { CertificationsPage } from './pages/CertificationsPage';
import { CertificationDetailPage } from './pages/CertificationDetailPage';
import { NewsPage } from './pages/NewsPage';
import { NewsArticlePage } from './pages/NewsArticlePage';
import { ManufacturingHubPage } from './pages/ManufacturingHubPage';
import { DefenceProcurementPage } from './pages/DefenceProcurementPage';
import { CataloguesPage } from './pages/CataloguesPage';
import { FaqsPage } from './pages/FaqsPage';
export function App() {
  return <HashRouter data-id="element-0">
      <ScrollToTop data-id="element-1" />
      <div className="min-h-screen bg-white flex flex-col" data-id="element-2">
        <Navigation data-id="element-3" />
        <main className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<HomePage data-id="element-7" />} data-id="element-6" />
            {/* About Us */}
            <Route path="/about" element={<AboutHubPage data-id="element-9" />} data-id="element-8" />
            <Route path="/about/who-we-are" element={<WhoWeArePage data-id="element-11" />} data-id="element-10" />
            <Route path="/about/what-we-do" element={<WhatWeDoPage data-id="element-13" />} data-id="element-12" />
            <Route path="/about/certifications" element={<CertificationsPage data-id="element-15" />} data-id="element-14" />
            <Route path="/about/certifications/:id" element={<CertificationDetailPage data-id="element-17" />} data-id="element-16" />
            <Route path="/about/news" element={<NewsPage data-id="element-19" />} data-id="element-18" />
            <Route path="/about/news/:slug" element={<NewsArticlePage data-id="element-21" />} data-id="element-20" />
            {/* Manufacturing */}
            <Route path="/manufacturing" element={<ManufacturingHubPage data-id="element-23" />} data-id="element-22" />
            <Route path="/manufacturing/markets" element={<SectorsHubPage data-id="element-25" />} data-id="element-24" />
            <Route path="/manufacturing/markets/:slug" element={<SectorPage data-id="element-27" />} data-id="element-26" />
            <Route path="/manufacturing/processes" element={<CapabilitiesHubPage data-id="element-29" />} data-id="element-28" />
            <Route path="/manufacturing/processes/:slug" element={<CapabilityPage data-id="element-31" />} data-id="element-30" />
            <Route path="/manufacturing/defence-procurement" element={<DefenceProcurementPage data-id="element-33" />} data-id="element-32" />
            <Route path="/manufacturing/frameworks" element={<FrameworksPage data-id="element-35" />} data-id="element-34" />
            <Route path="/manufacturing/catalogues" element={<CataloguesPage data-id="element-37" />} data-id="element-36" />
            {/* Support */}
            <Route path="/faqs" element={<FaqsPage data-id="element-39" />} data-id="element-38" />
            {/* Legacy/Other */}
            <Route path="/who-we-are" element={<WhoWeArePage data-id="element-41" />} data-id="element-40" />{' '}
            {/* Keep for redirect safety if needed, but nav uses /about/who-we-are */}
            <Route path="/sectors" element={<SectorsHubPage data-id="element-43" />} data-id="element-42" />
            <Route path="/capabilities" element={<CapabilitiesHubPage data-id="element-45" />} data-id="element-44" />
            <Route path="/frameworks" element={<FrameworksPage data-id="element-47" />} data-id="element-46" />
            <Route path="/products" element={<ProductsHubPage data-id="element-49" />} data-id="element-48" />
            <Route path="/products/:slug" element={<ProductPage data-id="element-51" />} data-id="element-50" />
            <Route path="/contact" element={<ContactPage data-id="element-53" />} data-id="element-52" />
            <Route path="/privacy-policy" element={<PrivacyPolicyPage data-id="element-55" />} data-id="element-54" />
            <Route path="/terms-of-service" element={<TermsOfServicePage data-id="element-57" />} data-id="element-56" />
            <Route path="/cookie-policy" element={<CookiePolicyPage data-id="element-59" />} data-id="element-58" />
            <Route path="/supplier-network" element={<SupplierNetworkPage data-id="element-61" />} data-id="element-60" />
            <Route path="*" element={<NotFoundPage data-id="element-63" />} data-id="element-62" />
          </Routes>
        </main>
        <Footer data-id="element-64" />
        <CookieBanner data-id="element-65" />
        <BackToTopButton data-id="element-66" />
      </div>
    </HashRouter>;
}